// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { ReactWidget } from '@jupyterlab/ui-components';
import React, { useEffect, useState } from 'react';
/**
 * The body for a Callstack Panel.
 */
export class CallstackBody extends ReactWidget {
    /**
     * Instantiate a new Body for the Callstack Panel.
     *
     * @param model The model for the callstack.
     */
    constructor(model) {
        super();
        this._model = model;
        this.addClass('jp-DebuggerCallstack-body');
    }
    /**
     * Render the FramesComponent.
     */
    render() {
        return React.createElement(FramesComponent, { model: this._model });
    }
}
/**
 * A React component to display a list of frames in a callstack.
 *
 * @param {object} props The component props.
 * @param props.model The model for the callstack.
 * @returns A JSX element.
 */
const FramesComponent = ({ model }) => {
    const [frames, setFrames] = useState(model.frames);
    const [selected, setSelected] = useState(model.frame);
    const onSelected = (frame) => {
        setSelected(frame);
        model.frame = frame;
    };
    useEffect(() => {
        const updateFrames = () => {
            setSelected(model.frame);
            setFrames(model.frames);
        };
        model.framesChanged.connect(updateFrames);
        return () => {
            model.framesChanged.disconnect(updateFrames);
        };
    }, [model]);
    return (React.createElement("ul", null, frames.map(ele => {
        var _a, _b, _c, _d;
        return (React.createElement("li", { key: ele.id, onClick: () => onSelected(ele), className: (selected === null || selected === void 0 ? void 0 : selected.id) === ele.id
                ? 'selected jp-DebuggerCallstackFrame'
                : 'jp-DebuggerCallstackFrame' },
            React.createElement("span", { className: 'jp-DebuggerCallstackFrame-name' }, ele.name),
            React.createElement("span", { className: 'jp-DebuggerCallstackFrame-location', title: (_a = ele.source) === null || _a === void 0 ? void 0 : _a.path }, (_c = (_b = model.getDisplayName) === null || _b === void 0 ? void 0 : _b.call(model, ele)) !== null && _c !== void 0 ? _c : (_d = ele.source) === null || _d === void 0 ? void 0 : _d.path)));
    })));
};
//# sourceMappingURL=body.js.map